module.exports = __webpack_public_path__ + "static/media/ic-nav-overview-active.850f1153.svg";